/* eslint-disable max-lines */
import { createApp , reactive} from 'vue';
import App from './App.vue';
import BackendNotFound from './views/ViewTopic/404NotFOund/BackendNotFound.vue';
import router from './router';
import {clear_token, get_token, set_client_feature_flags} from './router';
import {
  get_vapid_public_key,
  get_web_push_permission,
  is_web_push_supported,
  subscribe_to_web_push,
  sync_existing_web_push_subscription
} from '@/services/web_push';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
 
import '@/assets/css/new_style.css';
 
import AllCommunityAssets from './components/GetCommunityAssets/CommunityAsset.vue';
import CommunityAssetModal from './components/CommunityAssetModal/CommunityAssetModal.vue';
import FloatingButton from './components/FloatingButton/FloatingButtonComponent.vue';
import canCreateDirective from './directives/can_create';
 
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import {
  connect_organisation_realtime_socket,
  connect_realtime_socket,
  disconnect_portal_realtime_socket,
  disconnect_realtime_socket,
  set_realtime_socket_auth_checker
} from "./services/realtime";
// Set up the global AJAX handler
$(document).ajaxComplete(function(event, xhr) {
    if (xhr.status === 401) {
        clear_token();
        window.location.href = escape("/");
    }
});

// Export a promise that resolves with client domain
export let client_domain = '';

export const client_features = reactive({});

const S3_IMAGES_BASE_URL = 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/';

function s3Image(path) {
  const webp_path = String(path || '').replace(/\.[^/.]+$/, '.webp');

  return S3_IMAGES_BASE_URL + webp_path
    .split('/')
    .map(segment => encodeURIComponent(segment))
    .join('/');
}

const CLIENT_LOGOS = {
  Chamber: s3Image('ictchamberlogo.webp'),
  Workstreams: s3Image('workstreams_color_logo.webp'),
  vsi: s3Image('epf_black_logo.webp'),
  Engagenet: s3Image('engagenet_blue_2.webp'),
  Sandton: s3Image('919_logo.webp'),
  Community: s3Image('funaxlogo.webp'),
  Legacy: s3Image('legacy_build.webp'),
  Workbook: s3Image('aic_logo.webp'),
  CBO: s3Image('cbo-logo.webp'),
  TDM: s3Image('tdm.webp'),
  NSP: s3Image('NSP Logo.webp'),
  DWYPD: s3Image('dwypd_clear_logo.webp'),
  BOSA: s3Image('bosa_black.webp'),
  REMAT: s3Image('EngageNet Remat.webp'),
  chiefluthuli: s3Image('chiefluthuli_image/Luthuli_crest.webp'),
  Apex: s3Image('Apex_solve_logos/apex_logo_variants-03.webp'),
  vettedsa:s3Image('vetted_sa/vettedsa_logo.webp'),
  aicreads: s3Image('engagenet_white.webp'),
  aicone: s3Image('engagenet_white.webp'),

};

const SIDE_LOGOS = {
  Chamber: s3Image('ictchamberlogo.webp'),
  Workstreams: s3Image('workstreams_color_logo.webp'),
  vsi: s3Image('epf_black_logo.webp'),
  Engagenet: s3Image('Engagenet black.webp'),
  Sandton: s3Image('919_logo.webp'),
  Community: s3Image('funaxlogo.webp'),
  Legacy: s3Image('legacy_build.webp'),
  Workbook: s3Image('aic_logo.webp'),
  CBO: s3Image('cbo_logo.webp'),
  TDM: s3Image('tdm.webp'),
  NSP: s3Image('NSP Logo.webp'),
  DWYPD: s3Image('women_logo.webp'),
  BOSA: s3Image('bosa_black.webp'),
  REMAT: s3Image('EngageNet Remat.webp'),
  chiefluthuli: s3Image('chiefluthuli_image/Luthuli.webp'),
  Apex: s3Image('Apex_solve_logos/apex_logo_variants-03.webp'),
  vettedsa:s3Image('vetted_sa/Vetted_sa_main_logo.webp'),
  aicreads: s3Image('Engagenet black.webp'),
  aicone: s3Image('Engagenet black.webp'),




};

const CLIENT_BACKGROUNDS = {
  Workstreams: s3Image('workstream_background.webp'),
  vsi: s3Image('epf_black_logo.webp'),
  Sandton: s3Image('new_background.webp'),
  Chamber: s3Image('chamber_background.webp'),
  Community: s3Image('funaxbackground.webp'),
  Legacy: s3Image('legacy_background.webp'),
  Workbook: s3Image('aic_background.webp'),
  CBO: s3Image('cbo_background.webp'),
  TDM: s3Image('tdm_background.webp'),
  NSP: s3Image('soulcity_bg.webp'),
  DWYPD: s3Image('dwypd_bg.webp'),
  BOSA: s3Image('bosa_bg.webp'),
  REMAT: s3Image('new-bg.webp'),
  chiefluthuli: s3Image('chiefluthuli_image/Luthuli.webp'),
  vettedsa:s3Image('vetted_sa/Vetted_sa_main_logo.webp'),
  aicreads: s3Image('aic_background.webp'),
  aicone: s3Image('aic_background.webp'),



};

const AICONE_LOGO = {
  Engagenet: s3Image('aicone_logo_v3.webp'),
  Apex: s3Image('apex_solve_aicone/solve.webp'),

};

const PROBA_WORKFLOWS_LOGO = {
  Engagenet: s3Image('platform_icons/proba.webp')


};

const PROBA_ANALYTICS_LOGO = {
  Engagenet: s3Image('platform_icons/proba.webp'),
  Apex: s3Image('apex_solve_aicone/data.webp'),


};

const ENGAGENET_LOGO = {
  Engagenet: s3Image('platform_icons/engagenet.webp'),
  Apex: s3Image('apex_solve_aicone/engage.webp'),


};


const XVERDICT_LOGO = {
  Engagenet: s3Image('platform_icons/xverdict.webp')

};

const ORCAA_LOGO = {
  Engagenet: s3Image('platform_icons/orcaa.webp'),


};

const COMPLYON_LOGO = {
  Engagenet: s3Image('platform_icons/complyon.webp'),
  Apex: s3Image('apex_solve_aicone/onboarding.webp'),

};

const SECTION_BACKGROUNDS = {
  Workstreams: s3Image('workstreams_banner.webp'),
  Sandton: s3Image('919_bg.webp'),
  Chamber: s3Image('chamber_background.webp'),
  Community: s3Image('funaxback.webp'),
  Legacy: s3Image('legacy_background.webp'),
  Workbook: s3Image('ai_banner.webp'),
  CBO: s3Image('cbo_banner.webp'),
  TDM: s3Image('tdm_background.webp'),
  NSP: s3Image('soulcity_background.jpeg'),
  DWYPD: s3Image('women_logo.webp'),
  BOSA: s3Image('bosa_banner.webp'),
  REMAT: s3Image('about.webp'),
  chiefluthuli: s3Image('chiefluthuli_image/Luthuli.webp'),
  vettedsa:s3Image('vetted_sa/Vetted_sa_main_logo.webp'),
  aicreads: s3Image('ai_banner.webp')



};

const FAVICON_LOGOS = {
  Chamber: s3Image('ict-chamber-logo.webp'),
  Workstreams: s3Image('probafav.webp'),
  vsi: s3Image('epf_favicon_logo.webp'),
  Engagenet: s3Image('engagenet_white.webp'),
  Sandton: s3Image('sandton_digital_favicon.webp'),
  Community: s3Image('funaxlogo.webp'),
  Legacy: s3Image('legacy_build.webp'),
  Workbook: s3Image('1.webp'),
  CBO: s3Image('cbo_favicon.webp'),
  TDM: s3Image('tdm.webp'),
  NSP: s3Image('NSP Logo.webp'),
  DWYPD: s3Image('dwypd_clear_logo.webp'),
  BOSA: s3Image('bosa_black.webp'),
  REMAT: s3Image('8.webp'),
  chiefluthuli: s3Image('chiefluthuli_image/Luthuli_crest.webp'),
  Apex: s3Image('Apex_solve_logos/apex_logo_variants-07.webp'),
  vettedsa: s3Image('vetted_sa/Vetted_sa_main_logo.webp')
};

function normalizeClientKey(client) {
  const client_name = String(client || '').toLowerCase();
  return Object.keys(CLIENT_LOGOS).find(key => key.toLowerCase() === client_name) || client;
}
 
function getClientLogo(client) {
  return Reflect.get(CLIENT_LOGOS, normalizeClientKey(client))
    || s3Image('workstreams_color_logo.webp');
}
 
function getSideLogo(client) {
  return Reflect.get(SIDE_LOGOS, normalizeClientKey(client))
    || s3Image('Engagenet black.webp');
}
 
function getClientBgImage(client) {
  return Reflect.get(CLIENT_BACKGROUNDS, normalizeClientKey(client));
}
 
function getBackgroundSection(client) {
  return Reflect.get(SECTION_BACKGROUNDS, normalizeClientKey(client))
}

function getFaviconLogo(client) {
  return Reflect.get(FAVICON_LOGOS, normalizeClientKey(client))
    || s3Image('engagenet_white.webp');
}

function getComplyonLogo(client) {
  return Reflect.get(COMPLYON_LOGO, normalizeClientKey(client))
    || s3Image('engagenet_bg.webp');
}

function getOrcaaLogo(client) {
  return Reflect.get(ORCAA_LOGO, normalizeClientKey(client))
    || s3Image('engagenet_bg.webp');
}

function getXverdictLogo(client) {
  return Reflect.get(XVERDICT_LOGO, normalizeClientKey(client));
}

function getProbaanalyticLogo(client) {
  return Reflect.get(PROBA_ANALYTICS_LOGO, normalizeClientKey(client));
}

function getProbaworkflowsLogo(client) {
  return Reflect.get(PROBA_WORKFLOWS_LOGO, normalizeClientKey(client))
}

function getAiconeLogo(client) {
  return Reflect.get(AICONE_LOGO, normalizeClientKey(client));
}

function getEngageLogo(client) {
  return Reflect.get(ENGAGENET_LOGO, normalizeClientKey(client));
}
 
let appMounted = false;
let initialRouteReady = false;
let webPushPromptInProgress = false;
const WEB_PUSH_PROMPT_ID = 'web-push-enable-prompt';

function showGlobalLoader(delay = 120) {
  if (typeof window === 'undefined') return;
  window.engagenetLoader?.show?.(delay);
}

function hideGlobalLoader() {
  if (typeof window === 'undefined') return;
  window.engagenetLoader?.hide?.();
}

function afterNextPaint(callback) {
  if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
    window.setTimeout(callback, 0);
    return;
  }

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(callback);
  });
}

router.beforeEach((to, from, next) => {
  if (to.fullPath !== from.fullPath) {
    showGlobalLoader();
  }
  next();
});

router.afterEach(() => {
  if (!initialRouteReady) return;
  afterNextPaint(hideGlobalLoader);
});

router.onError(() => {
  hideGlobalLoader();
});

function closeWebPushPrompt() {
  const existingPrompt = document.getElementById(WEB_PUSH_PROMPT_ID);
  if (existingPrompt) existingPrompt.remove();
  webPushPromptInProgress = false;
}

function showWebPushPrompt({ token, userId }) {
  if (document.getElementById(WEB_PUSH_PROMPT_ID)) return;

  const overlay = document.createElement('div');
  overlay.id = WEB_PUSH_PROMPT_ID;
  overlay.className = 'web-push-enable-prompt';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');

  const panel = document.createElement('div');
  panel.className = 'web-push-enable-prompt__panel';

  const title = document.createElement('h3');
  title.textContent = 'Enable notifications?';
  title.className = 'web-push-enable-prompt__title';

  const body = document.createElement('p');
  body.textContent = 'Get important updates even when you are not actively using the app.';
  body.className = 'web-push-enable-prompt__body';

  const errorText = document.createElement('p');
  errorText.className = 'web-push-enable-prompt__error d-none';

  const actions = document.createElement('div');
  actions.className = 'web-push-enable-prompt__actions';

  const notNowButton = document.createElement('button');
  notNowButton.type = 'button';
  notNowButton.textContent = 'Not now';
  notNowButton.className = 'web-push-enable-prompt__button web-push-enable-prompt__button--secondary';

  const enableButton = document.createElement('button');
  enableButton.type = 'button';
  enableButton.textContent = 'Enable';
  enableButton.className = 'web-push-enable-prompt__button web-push-enable-prompt__button--primary';

  notNowButton.addEventListener('click', () => {
    sessionStorage.setItem(`webPushPromptDismissed:${userId}`, 'true');
    closeWebPushPrompt();
  });

  enableButton.addEventListener('click', async () => {
    enableButton.disabled = true;
    enableButton.textContent = 'Enabling...';
    errorText.classList.add('d-none');

    try {
      await subscribe_to_web_push({
        baseUrl: process.env.VUE_APP_BACKEND_API_URL,
        token,
        userId,
        projectId: process.env.VUE_APP_PROJECT_ID
      });
      closeWebPushPrompt();
    } catch (error) {
      errorText.textContent = error.message || 'Could not enable browser notifications.';
      errorText.classList.remove('d-none');
      enableButton.disabled = false;
      enableButton.textContent = 'Enable';
    }
  });

  actions.append(notNowButton, enableButton);
  panel.append(title, body, errorText, actions);
  overlay.appendChild(panel);
  document.body.appendChild(overlay);
}

function promptForWebPushOnAnyRoute() {
  const token = get_token();
  const userId = localStorage.getItem('user_id');

  if (!token || !userId) return;
  if (!is_web_push_supported() || !get_vapid_public_key()) return;
  if (get_web_push_permission() !== 'default') return;
  if (webPushPromptInProgress) return;

  const dismissedKey = `webPushPromptDismissed:${userId}`;
  if (sessionStorage.getItem(dismissedKey) === 'true') return;

  webPushPromptInProgress = true;
  showWebPushPrompt({ token, userId });
}

const updateFavicon = (client) => {
  const favicon = document.querySelector("link[rel='icon']");
  const apple_icon = document.querySelector("link[rel='apple-touch-icon']");
  const logo_path = getFaviconLogo(client);
  // Update standard Favicon
  if (favicon) {
    favicon.href = logo_path;
  }

  // Update Apple Touch Icon (Essential for iPad)
  if (apple_icon) {
    apple_icon.href = logo_path;
  }
};

function update_meta_tags(data, client) {
  const title = data.title || client;
  const description = data.welcome_text || `${client} - Your platform`;

  // Update title
  document.title = title;

  // Update or create meta description
  let metaDesc = document.querySelector('meta[name="description"]');
  if (!metaDesc) {
    metaDesc = document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    document.head.appendChild(metaDesc);
  }
  metaDesc.setAttribute('content', description);

  // Open Graph
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (!ogTitle) {
    ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    document.head.appendChild(ogTitle);
  }
  ogTitle.setAttribute('content', title);

  let ogDesc = document.querySelector('meta[property="og:description"]');
  if (!ogDesc) {
    ogDesc = document.createElement('meta');
    ogDesc.setAttribute('property', 'og:description');
    document.head.appendChild(ogDesc);
  }
  ogDesc.setAttribute('content', description);

  let ogImage = document.querySelector('meta[property="og:image"]');
  if (!ogImage) {
    ogImage = document.createElement('meta');
    ogImage.setAttribute('property', 'og:image');
    document.head.appendChild(ogImage);
  }
  ogImage.setAttribute('content', getClientLogo(client));
}

function has_realtime_auth() {
  return Boolean(get_token());
}

function sync_realtime_socket_connection() {
  if (has_realtime_auth()) {
    connect_realtime_socket();
    connect_organisation_realtime_socket();
    return;
  }

  disconnect_realtime_socket();
  disconnect_portal_realtime_socket();
}

set_realtime_socket_auth_checker(has_realtime_auth);
window.addEventListener("auth:cleared", sync_realtime_socket_connection);

function mountApp(client = 'Engagenet', data = {}) {
  if (appMounted) return client_domain;

  const client_key = normalizeClientKey(client);
  document.title = data.title || client_key;
  client_domain = client_key.toLowerCase();
  document.documentElement.setAttribute('data-client', client_key);


  if (data.features) {
    Object.assign(client_features, data.features);
  }
  set_client_feature_flags(client_features);

  const app = createApp(App);
  sync_realtime_socket_connection();
  app.provide('client_features', client_features);
  app.component('AllCommunityAssets', AllCommunityAssets);
  app.component('CommunityAssetModal', CommunityAssetModal);
  app.component('FloatingButton', FloatingButton);
  app.component('QuillEditor', QuillEditor);
  app.directive('can-create', canCreateDirective);

  app.config.globalProperties.$clientLogo = getClientLogo(client_key);
  app.config.globalProperties.$sideLogo = getSideLogo(client_key);
  app.config.globalProperties.$clientBgImage = getClientBgImage(client_key);
  app.config.globalProperties.$backgroundSection = getBackgroundSection(client_key);
  app.config.globalProperties.$welcomeText = data.welcome_text;
  app.config.globalProperties.$title = data.title || client_key;
  app.config.globalProperties.$Complyon = getComplyonLogo(client_key);
  app.config.globalProperties.$Orcaa = getOrcaaLogo(client_key);
  app.config.globalProperties.$Xverdict = getXverdictLogo(client_key);
  app.config.globalProperties.$probaanalytics = getProbaanalyticLogo(client_key);
  app.config.globalProperties.$probaworkflows = getProbaworkflowsLogo(client_key);
  app.config.globalProperties.$aicone = getAiconeLogo(client_key);
  app.config.globalProperties.$Engage = getEngageLogo(client_key);

  updateFavicon(client_key);
  update_meta_tags(data, client_key);

  app.mixin({
      mounted() {
          if (this.$title) document.title = this.$title;
      }
  });

  app.use(router).mount('#app');
  router.afterEach(() => {
    sync_realtime_socket_connection();
    window.setTimeout(promptForWebPushOnAnyRoute, 500);
  });

  document.documentElement.style.setProperty('--client-bg-image', `url(${app.config.globalProperties.$clientBgImage})`);

  if (app.config.globalProperties.$backgroundSection) {
    document.documentElement.style.setProperty('--client-bg-section', `url(${app.config.globalProperties.$backgroundSection})`);
  } else {
    document.documentElement.style.removeProperty('--client-bg-section');
  }
  appMounted = true;
  router.isReady().then(() => {
    initialRouteReady = true;
    afterNextPaint(() => {
      window.dispatchEvent(new Event('app-mounted'));
    });
  });

  sync_existing_web_push_subscription({
    baseUrl: process.env.VUE_APP_BACKEND_API_URL,
    token: get_token(),
    userId: localStorage.getItem('user_id'),
    projectId: process.env.VUE_APP_PROJECT_ID
  }).catch(error => {
    console.warn('Web push sync skipped.', error);
  });

  window.setTimeout(promptForWebPushOnAnyRoute, 800);

  return client_domain;
}

function NotFound() {
  if (appMounted) return client_domain;

  client_domain = 'engagenet';
  document.title = '404 | Page Not Found';
  document.documentElement.setAttribute('data-client', 'Engagenet');
  updateFavicon('Engagenet');

  createApp(BackendNotFound).mount('#app');
  appMounted = true;
  initialRouteReady = true;
  afterNextPaint(() => {
    window.dispatchEvent(new Event('app-mounted'));
  });

  return client_domain;
}

// Load backend config
export const loadAppConfig = async () => {
  try {
      const res = await fetch(`${process.env.VUE_APP_BACKEND_API_URL}/config/`);

      if (!res.ok) {
        throw new Error(`Config request failed with status ${res.status}`);
      }

      const data = await res.json();
      const client = data.client || "Engagenet";
      return mountApp(client, data);
  } catch (err) {
      console.error("Failed to load backend config:", err);
      return NotFound();
  }
};
 
// Immediately load config
loadAppConfig();

